const state= {
    Items:{
        data:[],
        total:0,
        pages: {
            isCMS: '1',
            page:1,
            totalPage : 1,
            limit:25,
            filter:{}
        },
    },
    Loadings:{
        list: false,
        detail: false,
    },
    Item: null,
};

const getters = {
    Items : (state) => state.Items,
    Loadings : (state) => state.Loadings,
    Item : (state) => state.Item,
};

const actions = {
    async updateItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.put(`api/navision/${params.id}`, params)
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async deteleItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`/api/navision`, {
                data: {
                    ids: params
                }
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async getList({commit}, params){
        commit( 'setLoadings', {key:"list",val:true});
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/navision`, {params:params})
            .then(response => {
                commit( 'setLoadings', {key:"list",val:false});
                response.data.data.pages = params
                commit( 'setListItems', response.data.data );
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async exportNavision({commit}, params){
        commit( 'setLoadings', {key:"list",val:true});
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/navision/export`, params)
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async getNavisionCronjobList({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/navision/cron-job`, {params:params})
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async updateNavisionCronJob({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/navision/cron-job`, params)
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    }
};

const mutations = {
    setListItems (state,data) {
        data.pages.totalPage = Math.ceil(data.total / data.pages.limit )
        state.Items.data = data.items
        state.Items.total = data.total
        state.Items.pages = data.pages
    },
    setItem (state, data) {
        state.Item = data;
    },
    setLoadings (state,data) {
        state.Loadings[data.key] = data.val;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}